import { Box } from '@mui/material';

export default function NotFound() {
  return (
    <Box
      alignItems="center"
      display="flex"
      flex="1 1"
      flexDirection="column"
      justifyContent="center"
    >
      <Box fontSize="120px" fontWeight="700">
        Ошибка 404
      </Box>
      <Box fontSize="14px" marginTop="40px">
        Страница не найдена
      </Box>
    </Box>
  );
}
